import { render, staticRenderFns } from "./UpdateShortcut.vue?vue&type=template&id=813df464&scoped=true"
import script from "./UpdateShortcut.vue?vue&type=script&lang=js"
export * from "./UpdateShortcut.vue?vue&type=script&lang=js"
import style0 from "./UpdateShortcut.vue?vue&type=style&index=0&id=813df464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813df464",
  null
  
)

export default component.exports